// components/ui/Badge.js
import React from "react";
import { cn } from "../utils/helpers";

export function Badge({ className, variant = "default", children }) {
  const variants = {
    default: "bg-primary text-primary-foreground",
    secondary: "bg-secondary text-secondary-foreground",
    destructive: "bg-destructive text-destructive-foreground",
    outline: "border border-input",
  };

  const classes = cn(
    "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors",
    variants[variant],
    className
  );

  return <div className={classes}>{children}</div>;
}
